module.exports = __webpack_public_path__ + "48dde4241654dfb04fe7a1e0ddc11639.png";